/**
 * KAN-822 T9 — the one reader of the Vendor routing UI build flag.
 *
 * Every Vendor-content UI surface is DARK: the operator side (the Route to
 * Vendor action, the routed history view, the route status) and the reader side
 * (Vendor labels, the Vendor view, search's Vendor filter, the Vendor updates
 * section in Settings). Each is shown only when the build sets VITE_VENDOR_ROUTING_UI_ENABLED
 * to exactly "true", which no committed config does
 * (routing-ui-flag-dark.test.ts pins both facts). Called at render time so the
 * gate cannot be cached by a module.
 */
export function vendorRoutingUiEnabled(): boolean {
  return import.meta.env.VITE_VENDOR_ROUTING_UI_ENABLED === 'true'
}
